/* LP: July 4th Sale — countdown, sticky CTA, UGC carousel dots, UGC lightbox.
   Single instance per page; queries are id-scoped. */
(function () {
  'use strict';

  // Lazy-load the autoplay videos. They carry their URL in data-src so nothing
  // downloads on page load (the hero UGC clip alone is ~40MB); each loads and
  // plays only when it scrolls near the viewport, and pauses when it leaves.
  (function () {
    var vids = document.querySelectorAll('.lp-july video[data-src]');
    if (!vids.length) return;
    function load(v) { if (!v.src) v.src = v.getAttribute('data-src'); }
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) load(vids[i]);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          load(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (v.src) {
          v.pause();
        }
      });
    }, { rootMargin: '200px' });
    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  })();

  // Countdown to the sale deadline. Target ISO string comes from the markup
  // (data-lp-july-deadline) so the schema controls the date. Honest: it must
  // actually end then.
  (function () {
    var root = document.getElementById('lpJulyCountdown');
    if (!root) return;
    var target = new Date(root.getAttribute('data-lp-july-deadline')).getTime();
    if (isNaN(target)) return;
    var d = document.getElementById('lpJulyDays'),
        h = document.getElementById('lpJulyHrs'),
        m = document.getElementById('lpJulyMin'),
        s = document.getElementById('lpJulySec');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      if (d) d.textContent = pad(Math.floor(diff / 86400000));
      if (h) h.textContent = pad(Math.floor(diff % 86400000 / 3600000));
      if (m) m.textContent = pad(Math.floor(diff % 3600000 / 60000));
      if (s) s.textContent = pad(Math.floor(diff % 60000 / 1000));
    }
    tick();
    setInterval(tick, 1000);
  })();

  // Sticky CTA bar appears after the hero scrolls out of view.
  (function () {
    var bar = document.getElementById('lpJulySticky');
    var hero = document.querySelector('.lp-july .hero');
    if (!bar || !hero) return;
    function onScroll() {
      if (window.scrollY > hero.offsetHeight - 80) bar.classList.add('show');
      else bar.classList.remove('show');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // UGC carousel dots: track active card on scroll, jump on dot click.
  (function () {
    var car = document.getElementById('lpJulyUgc');
    var dotsWrap = document.getElementById('lpJulyUgcDots');
    if (!car || !dotsWrap) return;
    var cards = car.querySelectorAll('.ugc-vcard');
    var dots = dotsWrap.querySelectorAll('.ugc-dot');
    function step() { return cards.length ? cards[0].offsetWidth + 18 : 1; }
    function update() {
      var idx = Math.round(car.scrollLeft / step());
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('active', i === idx);
    }
    car.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    for (var i = 0; i < dots.length; i++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          car.scrollTo({ left: step() * i, behavior: 'smooth' });
        });
      })(i);
    }
    update();
  })();

  // UGC click-to-play: tapping a card opens the full video with sound.
  (function () {
    var lb = document.getElementById('lpJulyLightbox');
    var vid = document.getElementById('lpJulyLightboxVideo');
    var closeBtn = document.getElementById('lpJulyLightboxClose');
    var cards = document.querySelectorAll('.lp-july .ugc-vcard');
    if (!lb || !vid) return;
    function open(src) {
      if (!src) return;
      vid.src = src;
      vid.muted = false;
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
    }
    function close() {
      lb.classList.remove('open');
      vid.pause();
      vid.removeAttribute('src');
      vid.load();
      document.body.style.overflow = '';
    }
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        card.addEventListener('click', function () { open(card.getAttribute('data-video')); });
      })(cards[i]);
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();
})();
